module.exports = __webpack_public_path__ + "img/subscription.2b6586a0.svg";